import { Col, Form, Row } from "antd";
import Modal from "antd/lib/modal/Modal";
import React from "react";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnCard from "../common/adnCard/AdnCard";
import AdnInput from "../common/adnInput/AdnInput";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import { useTranslation } from "react-i18next";

export const CountryListPageForm = ({
  form,
  title,
  columns,
  handleOrderList,
  setVisible,
  visible,
  countries,
  addCountryModal,
  handleFinish,
  modalCountryId,
  loading,
  submitLoading,
  handleBlurName,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row>
          <Col span={24}>
            <AdnAddButton
              style={{ float: "right" }}
              name={t("country.buttons.addButton")}
              handleClick={addCountryModal}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={countries}
              pagination={false}
              handleChange={handleOrderList}
              totalRecords={countries.length}
            />
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={
          !modalCountryId
            ? t("country.modals.newCountry")
            : t("country.modals.editCountry")
        }
        open={visible}
        onOk={form.submit}
        okText={t("country.buttons.save")}
        onCancel={() => {
          setVisible(false);
        }}
        cancelText={t("country.buttons.back")}
        confirmLoading={submitLoading}
      >
        <Form
          form={form}
          name="form_in_modal"
          layout="vertical"
          onFinish={handleFinish}
        >
          <AdnInput
            name={"name"}
            label={t("country.labels.name")}
            placeholder={t("country.placeholders.insertName")}
            handleBlur={handleBlurName}
            maxLength={20}
            rules={[
              { required: true, message: t("country.validation.nameRequired") },
              { min: 2, message: t("country.validation.nameMinLength") },
            ]}
          />
          <AdnInput
            name={"code"}
            label={t("country.labels.code")}
            placeholder={t("country.placeholders.insertCode")}
            handleBlur={handleBlurName}
            maxLength={20}
            rules={[
              { required: true, message: t("country.validation.codeRequired") },
              { min: 2, max: 2, message: t("country.validation.codeLength") },
            ]}
          />
        </Form>
      </Modal>
    </>
  );
};
